<template>
  <div class="wlx-unified-login-wrapper wlx-basic-static-wrapper" style="height:auto;">
    <!--登陆弹窗-->
    <el-dialog :show-close="true" :visible.sync="scanVisible" top="12%" :close-on-click-modal="false" width="500px"
      class="unified-login-dialog-style">
      <div class="login-hade-tab clearfix">
        <div class="user-account-login active_login">
          <span style="float:left">IFPSM个人纸质证书申请</span>
        </div>
      </div>
      <div class="login-form-input clearfix">
        <el-form ref="form" :model="ruleForm" :rules="rules">
          <div class="from-account-login">
            <!-- <el-form-item>
              <el-select filterable clearable v-model="ruleForm.schoolId" placeholder="请选择学校" class="form_input">
                <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <div class="left-icon">
                <i class="wl-icon-xuexiao"></i>
              </div>
            </el-form-item> -->
            <el-form-item prop="displayname">
              <el-input placeholder="请输入姓名" prefix-icon="wl-icon-user" v-model="ruleForm.displayname"></el-input>
            </el-form-item>
            <el-form-item prop="idcard">
              <el-input placeholder="请输入身份证号" prefix-icon="wl-icon-jiaoxueguanli" v-model="ruleForm.idcard"></el-input>
            </el-form-item>
            <el-form-item prop="mobile">
              <el-input placeholder="请输入手机号" prefix-icon="wl-icon-shouji1" v-model="ruleForm.mobile"
                @keyup.enter.native="login()"></el-input>
            </el-form-item>

          </div>
          <el-form-item>
            <el-button type="primary" @click="login">开始申请</el-button>
          </el-form-item>

        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Bus from 'components/bus.js';
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
export default {
  data() {
    return {
      scanVisible: false,
      ruleForm: {
        schoolId: "",
        idcard: "",
        displayname: "",
        mobile: "",
      },
      rules: {
        displayname: [
          { required: true, message: "请输入申请人姓名", trigger: "change" }
        ],
        idcard: [
          { required: true, message: "请输入申请人身份证号", trigger: "change" }
        ],
        mobile: [{ required: true, message: "请输入申请人手机号", trigger: "change" }],
      },
      schoolList: []
    };
  },
  props: {
    isShow: {
      type: Object
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    },
    association: function () {
      return this.$store.state.association;
    }
  },
  created() {
    this.getSchoolList();
    if (localStorage["userId"] !== undefined) {
      this.$store.dispatch(MU_UPATE_AUTH).then(rt => { });
    }
    this.$store.dispatch(MU_UPATE_SCHOOL, { id: window.location.href });
  },
  watch: {
    isShow(val) {
      this.scanVisible = val.isShow;
    }
  },
  methods: {
    getSchoolList() {
      var that = this;
      this.$http
        .post("/api/common/login/getSchoolList", {
          schoolType: 'zwl'
        })
        .then(rst => {
          if (rst && rst.code > 0) {
            that.schoolList = rst.list;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },

    enterRegister() {
      this.$router.push({
        name: 'register'
      });
    },
    // 忘记密码
    rememberPassword() {
      this.$router.push({
        name: "password"
      });
    },
    openLoginDialog() {
      this.scanVisible = true;
    },
    login: function () {
      var that = this;
      this.loadingTip(true);
      this.$http
        .post("/api/XOrg/stuItcCertificate/stuItcLogin", {
          displayname: that.ruleForm.displayname,
          idcard: that.ruleForm.idcard,
          // associationId: that.association.Id
          mobile: this.ruleForm.mobile
        })
        .then(rst => {
          if (rst && rst.code > 0) {
            if (rst.code === 1) {
              localStorage["userName"] = this.ruleForm.userName;
              localStorage["userId"] = rst.userId;
            }
            this.$store.dispatch(MU_UPATE_AUTH).then(rt => {
              this.loadingTip(false);
              // 登录完获取回登录信息跳转
              this.$router.push({
                name: 'stuPaperCertApply',
                params: {
                  certificateId: 'dnmeaa2seqbkn9fqiaawfq'
                }
              });
            });
          } else {
            this.loadingTip(false);
            this.$message.warning(rst.msg);
          }
        });
    },
    loadingTip(is) {
      if (is) {
        this.$loading({
          lock: true,
          text: "正在登录..."
        });
      } else {
        this.$loading({}).close();
      }
    },
    target_() {
      let Urlname = "";
      if (this.$store.state.auth.userType === 1) {
        Urlname = "stuBasicInfo";
      } else if (this.$store.state.auth.userType === 2) {
        Urlname = "teaApply";
      } else if (this.$store.state.auth.userType === 3) {
        Urlname = "siteBasicInfo";
      } else if (this.$store.state.auth.userType === 5) {
        Urlname = "managerIndex";
      }
      return Urlname;
    }
  }
};
</script>

<style lang="scss"></style>
